const AlertType = {
	AddOrRemoved: {
		key: 'addOrRemoved',
		labelId: 'titles_added_removed',
	},
	Voted: {
		key: 'voted',
		doOfferCandidate: true,
		labelId: 'votes',
	},
	Commented: {
		key: 'commented',
		doOfferCandidate: true,
		labelId: 'comments',
	},
};

export default AlertType;
